import { render } from "./PromptCardSelectCategory.vue?vue&type=template&id=36fdc49c&scoped=true"
import script from "./PromptCardSelectCategory.vue?vue&type=script&lang=js"
export * from "./PromptCardSelectCategory.vue?vue&type=script&lang=js"

import "./PromptCardSelectCategory.vue?vue&type=style&index=0&id=36fdc49c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fdc49c"]])

export default __exports__